export default {
    loggedIn: (state) => {
        return state.token !== null && state.receivedPermissions
    },
    isLastSystemVersionRead: (state) => {
        if (!state.user) return true
        if (state.user.profile) return !!state.user.profile.lastSystemVersionRead

        return !!state.user.lastSystemVersionRead
    },
}
